import { TanstackField } from '../../../utils/forms'
import CreatableStringSelect from '../../Selects/CreatableStringSelect'

type Props<TKey extends string> = {
  caption?: React.ReactNode
  isRequired?: boolean
  label?: React.ReactNode
  placeholder?: string
  field: TanstackField<string[], TKey>
}
const CreatableStringSelectField = <TKey extends string>({
  caption,
  field,
  isRequired,
  label,
  placeholder,
}: Props<TKey>) => {
  const errorMessage = field.state.meta.errors.join(', ')

  return (
    <CreatableStringSelect
      caption={caption}
      errorMessage={errorMessage}
      isInvalid={!!errorMessage}
      isRequired={isRequired}
      label={label}
      onBlur={field.handleBlur}
      onValueChange={field.setValue}
      placeholder={placeholder}
      value={field.state.value}
    />
  )
}

export default CreatableStringSelectField
